import { Box } from '@qbe/ads-core';
import React from 'react';

interface CustomScrollBarProps {
  maxHeight?: number | string;
  children: React.ReactNode;
  scrollBarOffset?: boolean;
}

export const CustomScrollBar: React.FC<CustomScrollBarProps> = ({
  children,
  maxHeight = 170,
  scrollBarOffset = true,
}) => (
  <Box
    component="div"
    sx={{
      maxHeight: typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight,
      overflowY: 'auto',
      paddingRight: scrollBarOffset ? '20px' : undefined,
      overflowWrap: 'break-word',

      '&::-webkit-scrollbar': {
        width: '5px',
      },

      /* Track */
      '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 5px #e1e4e8',
        background: '#e1e4e8',
        borderRadius: '80px',
      },

      /* Handle */
      '&::-webkit-scrollbar-thumb': {
        background: '#8a94a6',
        borderRadius: '80px',
        height: '10px',
      },

      /* Handle on hover */
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }}
  >
    {children}
  </Box>
);

export default CustomScrollBar;
